var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            _c(
              "form",
              {
                staticClass: "form-horizontal well",
                attrs: { role: "form", name: "bulkBlockForm" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.onSubmit)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("BLOCK_NUMBERS_UPLOAD_INPUT"),
                        "hide-label": false,
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("BLOCK_NUMBERS_UPLOAD_INPUT_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "col-sm-9 col-md-4" },
                                  [
                                    _c("FileReader", {
                                      attrs: { "file-name": _vm.fileName },
                                      on: { load: _vm.parseFile }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.fileUploaded && _vm.validPhones.length > 0
                                  ? _c(
                                      "label",
                                      {
                                        staticClass:
                                          "form-group__label-required"
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.$t("ITEMS_AMOUNT", {
                                                amount: _vm.totalItems
                                              })
                                            ) +
                                            "\n          "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.fileUploaded && _vm.validPhones.length == 0
                                  ? _c("label", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "NO_VALID_PHONES_ERROR",
                                          expression: "'NO_VALID_PHONES_ERROR'"
                                        }
                                      ],
                                      staticClass:
                                        "form-group__label-required vv-invalid"
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.submited && !_vm.fileUploaded
                                  ? _c("label", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "NO_FILE",
                                          expression: "'NO_FILE'"
                                        }
                                      ],
                                      staticClass:
                                        "form-group__label-required vv-invalid"
                                    })
                                  : _vm._e()
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("BLOCK_NUMBERS_BLOCK_TYPE_INPUT"),
                        "hide-label": false,
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "BLOCK_NUMBERS_BLOCK_TYPE_INPUT_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "col-sm-9 col-md-4" },
                                  [
                                    _c("MultipleToggle", {
                                      attrs: {
                                        value: _vm.selectedBlockType,
                                        options: _vm.blockTypeOptions
                                      },
                                      on: {
                                        onToggle: function($event) {
                                          return _vm.blockTypeChange(
                                            $event,
                                            "selectedBlockType"
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.selectedBlockType === 1
                  ? _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("BLOCK_NUMBERS_CAMPAGIN_ID_INPUT"),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t(
                              "BLOCK_NUMBERS_CAMPAGIN_ID_INPUT_TT"
                            )
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-9 col-md-4" },
                                      [
                                        _c("SearchableDropdown", {
                                          staticClass: "m-0",
                                          attrs: {
                                            config: _vm.dropdownConfig,
                                            rules: "required"
                                          },
                                          model: {
                                            value: _vm.campaignId,
                                            callback: function($$v) {
                                              _vm.campaignId = $$v
                                            },
                                            expression: "campaignId"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-offset-3 col-sm-3" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "number-to-block-list bs-callout bs-callout-sm bs-callout-success description"
                      },
                      [
                        _c("p", [
                          _c("b", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "VALID_NUMBERS",
                                expression: "'VALID_NUMBERS'"
                              }
                            ]
                          }),
                          _vm._v(" "),
                          _vm.validPhones.length > 0
                            ? _c("span", {
                                directives: [
                                  {
                                    name: "t",
                                    rawName: "v-t",
                                    value: {
                                      path: "ITEMS_AMOUNT",
                                      args: { amount: _vm.validPhones.length }
                                    },
                                    expression:
                                      "{path: 'ITEMS_AMOUNT', args: {amount: validPhones.length}}"
                                  }
                                ],
                                staticClass: "text-muted"
                              })
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "list-unstyled" },
                          _vm._l(_vm.validPhones, function(number, index) {
                            return _c("li", { key: number + "-" + index }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(number) +
                                  "\n            "
                              )
                            ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.validPhones.length == 0
                          ? _c("p", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "NUMBERS_LIST_EMPTY",
                                  expression: "'NUMBERS_LIST_EMPTY'"
                                }
                              ],
                              staticClass: "text-center"
                            })
                          : _vm._e()
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-3" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "number-to-block-list bs-callout bs-callout-sm bs-callout-danger description"
                      },
                      [
                        _c("p", [
                          _c("b", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "INVALID_NUMBERS",
                                expression: "'INVALID_NUMBERS'"
                              }
                            ]
                          }),
                          _vm._v(" "),
                          _vm.invalidPhones.length > 0
                            ? _c("span", {
                                directives: [
                                  {
                                    name: "t",
                                    rawName: "v-t",
                                    value: {
                                      path: "ITEMS_AMOUNT",
                                      args: { amount: _vm.invalidPhones.length }
                                    },
                                    expression:
                                      "{path: 'ITEMS_AMOUNT', args: {amount: invalidPhones.length}}"
                                  }
                                ],
                                staticClass: "text-muted"
                              })
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "list-unstyled" },
                          _vm._l(_vm.invalidPhones, function(number, index) {
                            return _c("li", { key: number + "-" + index }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(number) +
                                  "\n            "
                              )
                            ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm.invalidPhones.length == 0
                          ? _c("p", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "NUMBERS_LIST_EMPTY",
                                  expression: "'NUMBERS_LIST_EMPTY'"
                                }
                              ],
                              staticClass: "text-center"
                            })
                          : _vm._e()
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-offset-2 col-md-offset-3 m-b-25" },
                    [
                      _c("button", {
                        directives: [
                          {
                            name: "t",
                            rawName: "v-t",
                            value: "BLOCK_NUMBERS_BUTTON_SAVE",
                            expression: "'BLOCK_NUMBERS_BUTTON_SAVE'"
                          }
                        ],
                        staticClass: "btn btn-primary m-t-20 m-l-20",
                        attrs: {
                          disabled: _vm.isPending,
                          name: "rtb-form-save-button",
                          type: "submit"
                        }
                      })
                    ]
                  )
                ])
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }